<template>
  <div>
    <OperationsPayrollTable ref="operation-payroll-table-component"/>
  </div>
</template>

<script>
import OperationsPayrollTable from "@/views/rrhh/views/payroll/components/operations-payroll/OperationsPayrollTable.vue";

export default {
  components: {
    OperationsPayrollTable,
  },
  methods:{
    refreshTable(){
      this.$refs["operation-payroll-table-component"].refreshTable();
    }
  },
};
</script>

<style>
</style>